import React from 'react';
import { X } from 'lucide-react';
type ModalType = 'terminos' | 'privacidad' | null;
interface LegalModalProps {
  type: ModalType;
  onClose: () => void;
}
export function LegalModal({
  type,
  onClose
}: LegalModalProps) {
  if (!type) return null;
  const content = {
    terminos: {
      title: 'Términos y Condiciones',
      body: <div className="space-y-4 text-gray-700 text-sm leading-relaxed" data-id="element-54">
          <p data-id="element-55">
            <strong data-id="element-56">1. Aceptación de los términos</strong>
            <br data-id="element-57" />
            Al adquirir "Cena de 7 Minutos", aceptas estos términos en su
            totalidad. Si no estás de acuerdo, no realices la compra.
          </p>
          <p data-id="element-58">
            <strong data-id="element-59">2. Producto digital</strong>
            <br data-id="element-60" />
            Este producto es una guía digital en formato PDF. Recibirás acceso
            inmediato tras la compra. No se envían productos físicos.
          </p>
          <p data-id="element-61">
            <strong data-id="element-62">3. Uso personal</strong>
            <br data-id="element-63" />
            La guía es para uso personal exclusivamente. Queda prohibida su
            reproducción, distribución o reventa total o parcial sin
            autorización escrita.
          </p>
          <p data-id="element-64">
            <strong data-id="element-65">4. Garantía</strong>
            <br data-id="element-66" />
            Ofrecemos una garantía de devolución de 7 días. Si no estás
            satisfecha, contáctanos dentro de ese plazo para un reembolso
            completo.
          </p>
          <p data-id="element-67">
            <strong data-id="element-68">5. Resultados</strong>
            <br data-id="element-69" />
            Los resultados varían según cada persona. Los testimonios mostrados
            son experiencias individuales y no garantizan resultados idénticos.
          </p>
          <p data-id="element-70">
            <strong data-id="element-71">6. Modificaciones</strong>
            <br data-id="element-72" />
            Nos reservamos el derecho de actualizar estos términos en cualquier
            momento. Las actualizaciones se publicarán en esta página.
          </p>
        </div>
    },
    privacidad: {
      title: 'Política de Privacidad',
      body: <div className="space-y-4 text-gray-700 text-sm leading-relaxed" data-id="element-73">
          <p data-id="element-74">
            <strong data-id="element-75">1. Información que recopilamos</strong>
            <br data-id="element-76" />
            Recopilamos únicamente los datos necesarios para procesar tu compra:
            nombre, correo electrónico e información de pago (procesada de forma
            segura por terceros).
          </p>
          <p data-id="element-77">
            <strong data-id="element-78">2. Uso de la información</strong>
            <br data-id="element-79" />
            Usamos tu información para entregar el producto, enviarte
            actualizaciones relacionadas y mejorar nuestros servicios. No
            vendemos ni compartimos tus datos con terceros.
          </p>
          <p data-id="element-80">
            <strong data-id="element-81">3. Correos electrónicos</strong>
            <br data-id="element-82" />
            Al comprar, aceptas recibir correos relacionados con tu compra.
            Puedes cancelar la suscripción en cualquier momento usando el enlace
            al final de cada correo.
          </p>
          <p data-id="element-83">
            <strong data-id="element-84">4. Seguridad</strong>
            <br data-id="element-85" />
            Utilizamos procesadores de pago seguros (SSL). No almacenamos
            información de tarjetas de crédito en nuestros servidores.
          </p>
          <p data-id="element-86">
            <strong data-id="element-87">5. Cookies</strong>
            <br data-id="element-88" />
            Este sitio puede usar cookies para mejorar tu experiencia de
            navegación. Puedes desactivarlas en la configuración de tu
            navegador.
          </p>
          <p data-id="element-89">
            <strong data-id="element-90">6. Contacto</strong>
            <br data-id="element-91" />
            Para cualquier pregunta sobre tu privacidad, escríbenos a:
            hola@cenade7minutos.com
          </p>
        </div>
    }
  };
  const {
    title,
    body
  } = content[type];
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={onClose} data-id="element-92">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" data-id="element-93"></div>

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[80vh] flex flex-col overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-94">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-100 bg-[#FDF6EC]" data-id="element-95">
          <h2 className="font-heading text-xl font-bold text-[#2C1810]" data-id="element-96">
            {title}
          </h2>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300 transition text-gray-600" data-id="element-97">
            <X className="w-4 h-4" data-id="element-98" />
          </button>
        </div>

        {/* Body */}
        <div className="overflow-y-auto p-6 font-body" data-id="element-99">{body}</div>

        {/* Footer */}
        <div className="p-4 border-t border-gray-100 text-center" data-id="element-100">
          <button onClick={onClose} className="bg-[#D4522A] hover:bg-[#B8401C] text-white font-heading font-bold px-8 py-2.5 rounded-lg transition text-sm" data-id="element-101">
            Cerrar
          </button>
        </div>
      </div>
    </div>;
}